import { render, staticRenderFns } from "./VersionSettings.vue?vue&type=template&id=c6a5da5c&"
import script from "./VersionSettings.vue?vue&type=script&lang=ts&"
export * from "./VersionSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports